
<div class="wraper">
  <div class="overlay" *ngIf="showSpinner">
    <div class="spinner-wrapper">
      <app-spinner></app-spinner>
    </div>
  </div>
  <div class="loaded-content" [class.blurred]="loading">
    <div class="overlay" *ngIf="loading">
      <div class="spinner-wrapper">
        <app-spinner>
          <span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span>
        </app-spinner>
      </div>
    </div>
    <div>
      <p-accordion value="1">
        <p-accordion-panel value="1">
          <p-accordion-header class="lightHeader">
            <div>
              Filters:
              <span class="mr-4">{{filterDisplay}}</span>
              <span *ngIf="totalRecords>0" class="float-right">{{totalRecords}} Test<span *ngIf="totalRecords>1">s</span> found</span>
              <span *ngIf="!totalRecords" class="float-right" style="color:#6c9184; font-weight:500; font-style:italic">Enter any field to search for send-out tests...</span>
            </div>
          </p-accordion-header>
          <p-accordion-content>

            <div class="grid p-ai-center vertical-container mt-2">
              <div class="col-12">
                <div class="grid">
                  <div class="col-2">
                    <label class="pull-right">Sample ID:</label>
                  </div>
                  <div class="col-2">
                    <input pInputText type="text" placeholder="Sample ID..." [(ngModel)]="filter.labSerialNumber" (keyup)="filterChanged()" style="margin-right: 15px;" />
                  </div>
                  <div class="col-2">
                    <label class="pull-right">Facility Name:</label>
                  </div>
                  <div class="col-2">
                    <input pInputText type="text" placeholder="Facility name..." [(ngModel)]="filter.facilityName" (keyup)="filterChanged()" style="margin-right: 15px;" />
                  </div>
                  <div class="col-2">
                    <label class="pull-right">Lab Name:</label>
                  </div>
                  <div class="col-2">
                    <input pInputText type="text" placeholder="Lab name..." [(ngModel)]="filter.labName" (keyup)="filterChanged()" style="margin-right: 15px;" />
                  </div>
                </div>
                <div class="grid">
                  <div class="col-2">
                    <label class="pull-right">Patient Name:</label>
                  </div>
                  <div class="col-2">
                    <input pInputText type="text" placeholder="Patient name..." [(ngModel)]="filter.patientName" (keyup)="filterChanged()" style="margin-right: 15px;" />
                  </div>
                  <div class="col-2">
                    <label class="pull-right">Birth Date:</label>
                  </div>
                  <div class="col-2">
                    <p-datepicker id="searchPatientDOB" name="searchPatientDOB" placeholder="Patient DOB..." [(ngModel)]="filter.patientDateOfBirth" (keyup)="filterChanged()" (onSelect)="filterChanged()"></p-datepicker>
                  </div>
                </div>
                <div class="grid">
                  <div class="col-12">
                    <p-button (click)="searchButtonClicked()" label="  Search" icon="far fa-filter" iconPos="left" [disabled]="searchDisabled || loading"></p-button>
                  </div>
                </div>

              </div>

            </div>
          </p-accordion-content>

        </p-accordion-panel>
      </p-accordion>
    </div>
    <div>
      <p-table [hidden]="initialLoad" #reqlist [columns]="cols" [value]="dataRows" [lazy]="true" (onLazyLoad)="loadGridData($event)" [paginator]="true" styleClass="p-datatable-customers"
               [rows]="20" [totalRecords]="totalRecords" [loading]="loading" sortField="LabSerialCollectionDate" [sortOrder]="-1">
        <ng-template pTemplate="caption">
          <div style="height: 30px !important; width: 100%">
            <span class="float-left">Process Send-out Reports</span>
            <div class="float-right">
              <input pInputText type="text" [(ngModel)]="filter.gridFilter" (keypress)="handleGlobalGridSearchKey($event, reqlist)" placeholder="search..." style="margin-right: 15px;" />
              <a (click)="reqlist.exportCSV()" class="text-white iconbutton" title="Export CSV"><i class="fal fa-file-csv" [ngClass]="{'fa-spin':loading}"></i></a>
              <a (click)="loadGridData(null)" class="text-white iconbutton" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i></a>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="PatientFirstName" style="width:150px;">First Name <p-sortIcon field="PatientFirstName"></p-sortIcon></th>
            <th pSortableColumn="PatientLastName" style="width:150px;">Last Name <p-sortIcon field="PatientLastName"></p-sortIcon></th>
            <th pSortableColumn="PatientBirthDate" style="width:140px;">Birth Date <p-sortIcon field="PatientBirthDate"></p-sortIcon></th>
            <th pSortableColumn="PhysicianFirstName">Provider <p-sortIcon field="PhysicianFirstName"></p-sortIcon></th>
            <th pSortableColumn="FacilityName">Facility <p-sortIcon field="FacilityName"></p-sortIcon></th>
            <th pSortableColumn="LabSerialCollectionDate">Collection Date <p-sortIcon field="LabSerialCollectionDate"></p-sortIcon></th>
            <th pSortableColumn="LabSerialNumber">Accession/SID <p-sortIcon field="LabSerialNumber"></p-sortIcon></th>
            <th pSortableColumn="LabTestDescription">Test <p-sortIcon field="LabTestDescription"></p-sortIcon></th>
            <th pSortableColumn="MedTekTestStatus">Status <p-sortIcon field="MedTekTestStatus"></p-sortIcon></th>
            <th style="width:100px;">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{row.PatientFirstName}}</td>
            <td>{{row.PatientLastName}}</td>
            <td>{{row.PatientBirthDate | date:'shortDate'}}</td>
            <td>{{row.PhysicianFirstName}} {{row.PhysicianLastName}}</td>
            <td>{{row.FacilityName}}</td>
            <td>{{row.LabSerialCollectionDate  | date:'short'}}</td>
            <td>{{row.LabSerialNumber}}</td>
            <td>{{row.LabTestName}}</td>
            <td>{{row.LabStatusText}}<br />{{row.LabStatusDate | date:'short'}}</td>
            <td>
              <span *hasClaim="'PackageReq_Edit'">
                <a *ngIf="!row.LabTekTestIsRejected || !row.RequisitionId"
                   (click)="showUploadDocumentDialog(row)" class="iconbutton" title="Upload Results">
                  <i class="far fa-upload"></i>
                </a>
              </span>
              <span>
                <span *hasClaim="'PackageReq_Edit'">

                  <a *ngIf="!row.LabTekTestIsRejected && row.LabStatusText != 'Completed' && row.IsAccessDx"
                     (click)="rejectTest(row.LabSerialNumber, row.RequisitionTestId, row)" class="iconbutton" title="Reject Test">
                    <i class="far fa-thumbs-down"></i>
                  </a>
                  <!--TODO: Re-add "RejectionType != 3" check once RejectionType is actually available-->
                  <!--""-->
                  <a *ngIf="row.LabTekTestIsRejected && row.RejectionType != 3 && row.IsAccessDx"
                     (click)="unrejectTest(row.LabSerialNumber, row.RequisitionId,row.RequisitionTestId, row.RequisitionTestRejectionId)" class="iconbutton" title="Unreject Test">
                    <i class="far fa-thumbs-up"></i>
                  </a>
                  <!--""-->
                  <span *ngIf="row.LabTekTestIsRejected && row.RejectionType == 3 && row.IsAccessDx"
                        title="QNS rejections cannot be unrejected" class="disabled" disabled="disabled">
                    <i class="far fa-thumbs-up"></i>
                  </span>
                </span>
                <span *ngIf="row.RequisitionTestResultId && row.RequisitionTestResultId > 0 && row.IsAccessDx ">
                  <a (click)="getRequisitionTestResultReport(row.RequisitionTestResultId)" class="iconbutton" title="Get Test Report PDF">
                    <i class="far fa-print"></i>
                  </a>
                </span>
                <span *ngIf="!row.IsAccessDx"
                      title="Not an AccessDx order!" class="ml-2 mr-2">
                  <i class="fa fa-exclamation-circle"></i>
                </span>

              </span>
            </td>

          </tr>
        </ng-template>
      </p-table>
    </div>


    <app-rejectReason-dialog [(showRejectDialog)]="showRejectDialog"
                             [accession]=""
                             [(requisitionTestId)]="selectedRequisitionTestId"
                             [(rejectDescription)]="rejectDescription"
                             [(rejectReasons)]="rejectReasons"
                             (onReject)="rejectDialogOnClosed($event)">

    </app-rejectReason-dialog>
    <app-unreject-dialog [(showUnrejectDialog)]="showUnRejectDialog"
                         [(requisitionId)]="selectedRequisitionId"
                         [(requisitionTestRejectionId)]="selectedRequisitionTestRejectionId"
                         (onClose)="unrejectDialogOnClosed($event)">

    </app-unreject-dialog>


    <ngfFormData [files]="files"
                 postName="file"
                 [(FormData)]="uploadFormData"></ngfFormData>

    <p-dialog [(visible)]="showUploadDocument" (onHide)="closeUploadDocument(null)" [modal]="true">
      <ng-template #header>
        Upload Results Document for {{ selectedRow?.LabSerialNumber }}
      </ng-template>
      <div style="height: 400px;width:600px;">
        <div class="overlay" *ngIf="fileUploading">
          <div class="spinner-wrapper">
            <app-spinner>
              <span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span>
            </app-spinner>
          </div>
        </div>


        <!-- angular-file uploader  https://www.npmjs.com/package/angular-file-->
        <div class="row m-2">
          <div class="col-6"><label>Select File(s):</label></div>
          <div class="col-6">
            <p-button ngfSelect
                      multiple="1"
                      type="file"
                      [(files)]="files"
                      [accept]="acceptTypes"
                      (filesChange)="uploadFilesChanged()"
                      icon="far fa-file-pdf"
                      label="  Select...">
            </p-button>
          </div>
          <div class="row pt-1 font-weight-bold w-full text-center" style="border: dashed 1px black; height: 100px; display: flex; justify-content: center; align-items: center; "
               ngfDrop selectable="1" multiple="1"
               [(files)]="files" (filesChange)="uploadFilesChanged()">
            <span style="text-align: center; vertical-align: middle">Or drop here...</span>
          </div>
        </div>
        &nbsp;
        <div style="margin-bottom: 40px">
          <h4>{{files.length}} files selected</h4>

          <table class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Size</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of files;let i=index">
                <td>
                  <strong style="cursor:pointer" (click)="showFile($event, i)">{{ item.name }}</strong>
                </td>
                <td nowrap>
                  {{ item.size/1024/1024 | number:'.2' }} MB
                </td>
                <td nowrap>
                  <button type="button"
                          class="btn btn-danger btn-xs"
                          (click)="removeUploadFile(i)">
                    <span class="far fa-trash"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <ng-template #footer>
        <div class="row w-full">
          <div class="col-4">
            <div [hidden]="!showUploadOptions" class="w-full">
              <p-radioButton name="uploadOption" class="mb-2"
                             value="replace" [(ngModel)]="uploadOption" inputId="rbReplace"
                             [disabled]="files.length == 0">
              </p-radioButton>
              <label for="rbReplace" class="ml-2">Replace</label>
              &nbsp;
              <p-radioButton name="uploadOption" class="mb-2"
                             value="append" [(ngModel)]="uploadOption" inputId="rbAppend"
                             [disabled]="files.length == 0">
              </p-radioButton>
              <label for="rbAppend" class="ml-2">Append</label>
            </div>
          </div>
          <div class="col-4">
            <p-button [style]="{'width': '180px'}" (click)="clearUploadFiles()" label=" Clear" icon="far fa-eraser" iconPos="left" [disabled]="files.length == 0 || fileUploading"></p-button>&nbsp;
          </div>
          <div class="col-4">
            <p-button [style]="{'width': '180px'}" (click)="uploadFilesClick()" label=" Upload" icon="far fa-upload" iconPos="left" [disabled]="files.length == 0 || (showUploadOptions && !uploadOption) || fileUploading"></p-button>
          </div>
        </div>

      </ng-template>
    </p-dialog>

  </div>
</div>
<p-toast>
</p-toast>
